// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import AttachMoneyIcon from "@material-ui/icons/AttachMoney";

import type { StateType, DispatchType } from "../../../global/types/redux";
import TierItem from "../../components/quotes/TierItem";
import { GeneralModalForm } from "imagus-components";
import CreateTierFormRedux from "./CreateTierFormRedux";
import { propComparator } from "../../../global/functions/StringOperations";

type PriceTiersPropsType = {
  tiers: { [key: string]: * }
};

type PriceTiersStatesType = {
  modalOpen: boolean
};

class PriceTiers extends Component<PriceTiersPropsType, PriceTiersStatesType> {
  constructor(props: PriceTiersPropsType) {
    super(props);
    this.state = {
      modalOpen: false
    };
  }

  switchModalStatus = (status: boolean): * => {
    this.setState({ modalOpen: status });
  };

  render(): React$Element<*> {
    const tiers = this.props.tiers;
    tiers.sort(propComparator("name"));

    return (
      <div className="app-wrapper">
        <div className="app-panel">
          <div className="app-panel-content">
            <div className="item-header-container">
              <div className="right-div">
                <Button
                  type="button"
                  variant="contained"
                  color="primary"
                  className="dark-btn"
                  onClick={(): * => this.switchModalStatus(true)}
                >
                  <AttachMoneyIcon className="light-icon right-margin-5" />
                  Create New Tier
                </Button>
                <GeneralModalForm
                  title="Create New Tier"
                  open={this.state.modalOpen}
                  handleModalStatus={this.switchModalStatus}
                  form={
                    <CreateTierFormRedux
                      onClose={(): * => this.switchModalStatus(false)}
                    />
                  }
                />
              </div>
            </div>
            <Grid container spacing={24}>
              {tiers.map(
                (tier: *, i: number): React$Element<*> => (
                  <TierItem tier={tier} key={i} />
                )
              )}
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  tiers: state.v3account.quote.priceSheet.tiers
});

export default connect(mapStateToProps)(PriceTiers);
